import { Form } from '@mairistem/composants';
import { Combobox } from '@mairistem/finances-utils';
import { isNewIdentifiant, newIdentifiant, request } from '@mairistem/tools';
import { includes } from 'lodash';
import React from 'react';
import type { UtilisateurProjet } from '@/src/interfaces/utilisateurProjet';

interface UtilisateurProjetInputProps {
	onChange: any;
	utilisateursProjet: UtilisateurProjet[];
	identifiant: number;
	deletedUtilisateursProjet: number[];
}

const UtilisateurProjetInput = ({
	onChange = null,
	utilisateursProjet = null,
	deletedUtilisateursProjet = null,
	identifiant = null,
}: UtilisateurProjetInputProps) => {
	const [utilisateurs, setUtilisateurs] = React.useState([]);

	React.useEffect(() => {
		request.get('/api/utilisateurs/?all=true&actif=1').then(({ data }) =>
			setUtilisateurs(
				data.map((utilisateur) => {
					const textData = [
						`${utilisateur.nom ?? ''} ${utilisateur.prenom ?? ''}`,
						...(utilisateur.email ? [utilisateur.email] : []),
						...(utilisateur.portable ? [utilisateur.portable] : []),
					];
					return {
						key: utilisateur.identifiant,
						value: utilisateur.identifiant,
						text: `${utilisateur.nom ?? ''} ${utilisateur.prenom ?? ''}`,
						fullText: `${textData.join(' - ')}`,
						'data-testid': `optionUtilisateur${utilisateur.nom}`,
					};
				}),
			),
		);
	}, []);

	const getUtilisateursByValues = React.useCallback(
		(values) => {
			const elements = [];
			utilisateurs?.forEach((utilisateur: any) => {
				if (includes(values, utilisateur.value)) {
					elements.push({
						identifiantLogin: utilisateur?.value,
						identifiant:
							utilisateursProjet?.find(
								(up) => up.identifiantLogin === utilisateur.value,
							)?.identifiant ?? newIdentifiant(),
					});
				}
			});

			return elements;
		},
		[utilisateurs, utilisateursProjet],
	);

	const handleChange = React.useCallback(
		(_e, { value }) => {
			const newUtilisateursProjet = getUtilisateursByValues(value);
			const deletedUtilisateurs =
				utilisateursProjet
					?.filter(
						(utilisateur) =>
							!newUtilisateursProjet?.find(
								(nu) => nu.identifiant === utilisateur.identifiant,
							) && !isNewIdentifiant(utilisateur.identifiant),
					)
					?.map((utilisateur) => utilisateur?.identifiant) ?? [];

			onChange({
				identifiant,
				utilisateursProjet: newUtilisateursProjet,
				deletedUtilisateursProjet: [
					...(deletedUtilisateursProjet ?? []),
					...deletedUtilisateurs,
				],
			});
		},
		[
			getUtilisateursByValues,
			identifiant,
			deletedUtilisateursProjet,
			onChange,
			utilisateursProjet,
		],
	);

	const renderLabel = (item) => item?.fullText;

	return (
		<Form.Field
			control={Combobox}
			data-testid="utilisateursSubventionDropdown"
			// @ts-expect-error
			fluid
			label="Agent référent"
			placeholder="Agent référent"
			multiple
			noResultsMessage="Aucun agent trouvé"
			onChange={handleChange}
			options={utilisateurs ?? []}
			renderLabel={renderLabel}
			search
			selection
			value={
				utilisateursProjet?.map(
					(utilisateur) => utilisateur?.identifiantLogin,
				) ?? []
			}
		/>
	);
};

export default UtilisateurProjetInput;
